import { render, staticRenderFns } from "./email-attachments.vue?vue&type=template&id=c82713e4"
import script from "./email-attachments.vue?vue&type=script&lang=js"
export * from "./email-attachments.vue?vue&type=script&lang=js"
import style0 from "./email-attachments.vue?vue&type=style&index=0&id=c82713e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports